"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("../../core/utils");

var Supplier_1 = require("../model/Supplier");

var SupplierConverter_1 = require("./SupplierConverter");
/**
 *
 * Implementation of {@link SupplierConverter}
 * @author RV
 */


var SupplierConverterImpl =
/*#__PURE__*/
function (_SupplierConverter_1$) {
  _inherits(SupplierConverterImpl, _SupplierConverter_1$);

  function SupplierConverterImpl() {
    _classCallCheck(this, SupplierConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(SupplierConverterImpl).apply(this, arguments));
  }

  _createClass(SupplierConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new Supplier_1.Supplier(Supplier_1.Supplier.schema.id.valueOf(conversions.documentToClassId(source)), Supplier_1.Supplier.schema.externalId.valueOfField(source), Supplier_1.Supplier.schema.name.valueOfField(source), Supplier_1.Supplier.schema.registrationNumber.valueOfField(source), Supplier_1.Supplier.schema.currencyId.valueOf(conversions.toClassReferenceId(source.currencyId)), Supplier_1.Supplier.schema.active.valueOfField(source), Supplier_1.Supplier.schema.external.valueOfField(source), Supplier_1.Supplier.schema.consignmentSale.valueOfField(source), Supplier_1.Supplier.schema.processed.valueOfField(source));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        externalId: source.externalId,
        name: source.name,
        registrationNumber: utils_1.Utils.isValueMissing(source.registrationNumber) ? null : source.registrationNumber,
        currencyId: conversions.toDocumentReferenceId(source.currencyId),
        active: source.active,
        external: source.external,
        consignmentSale: source.consignmentSale,
        processed: source.processed
      });
      return result;
    }
  }]);

  return SupplierConverterImpl;
}(SupplierConverter_1.SupplierConverter);

exports.SupplierConverterImpl = SupplierConverterImpl;